/**
 * Preload images used by Level 1 (StartScene + GameScene + ShakeScene + MachineScene).
 * Level 2-only assets are loaded inside LV2 scenes' preload().
 */
export function preloadImages(scene) {
  // StartScene assets
  scene.load.image('BG', 'assets/StartScene/BG.png');
  scene.load.image('bottom1', 'assets/StartScene/bottom1.png');
  scene.load.image('bottom2', 'assets/StartScene/bottom2.png');
  scene.load.image('cloud', 'assets/StartScene/cloud.png');
  scene.load.image('play', 'assets/StartScene/play.png');
  scene.load.image('playBlack', 'assets/StartScene/playBlack.png');

  // GameScene image assets
  scene.load.image('BG2', 'assets/GameScene/newBG2.png');
  scene.load.image('bottom', 'assets/GameScene/newBottom3.png');
  scene.load.image('machine', 'assets/GameScene/machine.png');
  scene.load.image('basket', 'assets/GameScene/basket.png');
  scene.load.image('leftHandle', 'assets/GameScene/leftHandle.png');
  scene.load.image('rightHandle', 'assets/GameScene/rightHandle.png');
  scene.load.image('default', 'assets/GameScene/inputDefault.png');
  scene.load.image('typing', 'assets/GameScene/inputTyping.png');
  scene.load.image('correct', 'assets/GameScene/inputCorrect.png');
  scene.load.image('wrong', 'assets/GameScene/inputWrong.png');
  scene.load.image('cursor', 'assets/GameScene/cursor.png');
  scene.load.image('harvest', 'assets/GameScene/harvest.png');
  scene.load.image('harvestBlack', 'assets/GameScene/harvestBlack.png');
  scene.load.image('wheel', 'assets/GameScene/wheel.png');
  scene.load.image('wheelPart', 'assets/GameScene/wheelPart.png');
  scene.load.image('knob', 'assets/GameScene/knob.png');
  scene.load.image('bulb', 'assets/GameScene/bulb.png');
  scene.load.image('redBulb', 'assets/GameScene/redBulb.png');
  scene.load.image('overlay', 'assets/GameScene/overlay.png');
  scene.load.image('yay', 'assets/GameScene/yay.png');
  scene.load.image('distribute', 'assets/GameScene/distribute.png');
  scene.load.image('distributeBlack', 'assets/GameScene/distributeBlack.png');
  scene.load.image('bunchApples', 'assets/GameScene/bunchApples.png');
}
